import { useEffect, useState } from 'react'
import { fetchBlobUrl } from '@/lib/media'

/**
 * <img> for auth-protected media. Fetches the source as a blob (with the Clerk
 * token) and renders an object URL. Shows a neutral placeholder while loading
 * and on failure.
 */
export function AuthedImage({ src, alt = '', className = '', fallback, ...rest }) {
  const [url, setUrl] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let alive = true
    setUrl(null)
    setFailed(false)
    if (!src) {
      setFailed(true)
      return () => { alive = false }
    }
    fetchBlobUrl(src)
      .then((u) => { if (alive) setUrl(u) })
      .catch(() => { if (alive) setFailed(true) })
    return () => { alive = false }
  }, [src])

  if (failed) {
    return <div className={`${className} flex items-center justify-center bg-gray-100 text-gray-300 text-xs`}>{fallback || 'No image'}</div>
  }
  if (!url) {
    return <div className={`${className} bg-gray-100 animate-pulse`} />
  }
  return <img src={url} alt={alt} className={className} {...rest} />
}
